import { CSSProperties, ReactElement } from 'react';
import { Tooltip, TooltipProps } from '@material-ui/core';

interface STooltipProps extends Omit<TooltipProps, 'children'> {
  style?: CSSProperties;
  children: ReactElement;
}

const STooltip = ({
  title,
  style,
  children,
  ...tooltipProps
}: STooltipProps) => (
  <Tooltip title={title || ''} style={style} {...tooltipProps}>
    {children}
  </Tooltip>
);

export default STooltip;
